module.exports = __webpack_public_path__ + "img/ctagrid5.03576dcc.png";